import { Layout } from "antd";
import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { SideBar } from "../Common/SideBar";

export function MainLayout({ children, navList = [], categoryList = [] }) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: user, logout } = useAuth();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [pathname]);

  function handleNavClick({ key }) {
    navigate(key);
  }

  function handleLogout() {
    logout();
    navigate("/xac-thuc/dang-nhap");
  }

  if (!token) {
    return <Navigate to="/xac-thuc/dang-nhap" replace />;
  }

  return (
    <Layout
      style={{
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Layout.Sider
        width={250}
        theme="light"
        style={{
          height: "100vh",
          boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
          overflow: "auto",
        }}
      >
        <SideBar
          pathname={pathname}
          navList={navList || []}
          categoryList={categoryList || []}
          onNavCLick={handleNavClick}
          user={user}
          onLogout={handleLogout}
        />
      </Layout.Sider>
      <Layout.Content
        style={{
          height: "100vh",
          overflow: "auto",
        }}
      >
        {children}
      </Layout.Content>
    </Layout>
  );
}
